import { faMap, faMapMarkerAlt, faPlay, faWarning } from '@fortawesome/pro-regular-svg-icons';

import CatalanCoastContextSection from '@App/pages/CaseStudy/CatalanCoast/Context/Context';
import CatalanCoastMapSection from '@App/pages/CaseStudy/CatalanCoast/Map/Map';
import PagasitikosGulfContextSection from '@App/pages/CaseStudy/PagasitikosGulf/Context/Context';
import PagasitikosGulfDashboardSection from '@App/pages/CaseStudy/PagasitikosGulf/Dashboard/Dashboard';
import PagasitikosGulfMapSection from '@App/pages/CaseStudy/PagasitikosGulf/Map/Map';
import PagasitikosGulfScenariosSection from '@App/pages/CaseStudy/PagasitikosGulf/Scenarios/Scenarios';

const CASE_STUDY_SECTIONS = {
  'catalan-coast': [
    {
      id: 'context',
      label: 'Context',
      icon: faMapMarkerAlt,
      Component: CatalanCoastContextSection,
    },
    {
      id: 'map',
      label: 'Map',
      icon: faMap,
      Component: CatalanCoastMapSection,
    }],
  'pagasitikos-gulf': [{
    id: 'context',
    label: 'Context',
    icon: faMapMarkerAlt,
    Component: PagasitikosGulfContextSection,
  },
  {
    id: 'map',
    label: 'Map',
    icon: faMap,
    Component: PagasitikosGulfMapSection,
  },
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: faWarning,
    Component: PagasitikosGulfDashboardSection,
  },
  {
    id: 'scenarios',
    label: 'Scenarios',
    icon: faPlay,
    Component: PagasitikosGulfScenariosSection,
  }],
};

const CASE_STUDY_TITLES = {
  'catalan-coast': 'Catalan coast - Spain',
  'pagasitikos-gulf': 'Pagasitikos Gulf - Greece',
};

export {
  CASE_STUDY_SECTIONS,
  CASE_STUDY_TITLES,
};
